export function Loader() {
  return (
    <div className="p-heading--4 u-align-text--center">
      <i className="p-icon--spinner u-animation--spin" /> Loading...
    </div>
  );
}
